import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { FaChevronLeft, FaChevronRight, FaFire, FaMountain } from 'react-icons/fa';
import bannerImg from '../../../Assets/imagesssss/1/10008.jpg';
import vol1 from '../../../Assets/imagesssss/1/2.jpg';
import vol2 from '../../../Assets/imagesssss/1/2.jpg';
import vol3 from '../../../Assets/imagesssss/1/2.jpg';
import vol4 from '../../../Assets/imagesssss/1/2.jpg';
import vol5 from '../../../Assets/imagesssss/1/2.jpg';
import vol6 from '../../../Assets/imagesssss/1/2.jpg';
import rift1 from '../../../Assets/imagesssss/1/2.jpg';
import rift2 from '../../../Assets/imagesssss/1/2.jpg';
import rift3 from '../../../Assets/imagesssss/1/2.jpg';
import rift4 from '../../../Assets/imagesssss/1/2.jpg';
import rift5 from '../../../Assets/imagesssss/1/2.jpg';
import rift6 from '../../../Assets/imagesssss/1/2.jpg';

const VolcanoesAndRiftvalleys = () => {
  const [scrollPosition1, setScrollPosition1] = useState(0);
  const [scrollPosition2, setScrollPosition2] = useState(0);

  const volcanoes = [
    { id: 1, title: "Erta Ale Volcano", description: "Feel the Heat: Explore Afar's Fiery Wonders!", image: vol1 },
    { id: 2, title: "Dallol Volcano", description: "Stand at the Edge of Creation in Afar's Lava Fields.", image: vol2 },
    { id: 3, title: "Ale Bagu", description: "Dormant stratovolcano with impressive crater", image: vol3 },
    { id: 4, title: "Dubbre Volcano", description: "Witness Nature's Power at Afar's Thrilling Volcanoes!", image: vol4 },
    { id: 5, title: "Kurub Volcano", description: "Experience the Eternal Glow of Afar's Active Volcanoes!", image: vol5 },
    { id: 6, title: "Dama Ale", description: "From Lava Lakes to Fiery Peaks—Afar's Volcanoes Ignite Wonder.", image: vol6 }
  ];

  const riftValleys = [
    { id: 7, title: "Danakil Depression", description: "Journey Through Time in the Vast Afar Rift Valleys!", image: rift1 },
    { id: 8, title: "Afar Triangle", description: "Explore the Rift: Where Continents Divide and Adventures Begin!", image: rift2 },
    { id: 9, title: "Lake Afdera", description: "Step into Earth's Ancient Valleys in the Afar Region.", image: rift3 },
    { id: 10, title: "Salt Plains", description: "Afar Rift Valleys: Nature's Canvas of Time and Transformation.", image: rift4 },
    { id: 11, title: "Awash Valley", description: "Discover the Roots of Earth's Beauty in Afar's Rift Valleys!", image: rift5 },
    { id: 12, title: "Yangudi Rassa", description: "The Afar Rift Valleys: A Landscape Carved by Time, Ready to Inspire.", image: rift6 }
  ];

  const handleScroll = (direction, row) => {
    const scrollAmount = 300;
    const maxScroll = (row === 1 ? volcanoes.length : riftValleys.length - 1) * 300;
    const setPosition = row === 1 ? setScrollPosition1 : setScrollPosition2;

    setPosition(prev => {
      const newPosition = direction === 'left' ? prev - scrollAmount : prev + scrollAmount;
      return Math.max(0, Math.min(newPosition, maxScroll));
    });
  };

  const renderCarousel = (items, row) => (
    <div className="carousel-container">
      <ScrollButton direction="left" onClick={() => handleScroll('left', row)}>
        <FaChevronLeft />
      </ScrollButton>
      <CarouselViewport>
        <CarouselTrack
          style={{ transform: `translateX(-${row === 1 ? scrollPosition1 : scrollPosition2}px)` }}
        >
          {items.map(item => (
            <Card key={item.id} whileHover={{ y: -10 }} transition={{ duration: 0.3 }}>
              <CardImage>
                <img src={item.image} alt={item.title} />
                <CardOverlay />
              </CardImage>
              <CardContent>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </CarouselTrack>
      </CarouselViewport>
      <ScrollButton direction="right" onClick={() => handleScroll('right', row)}>
        <FaChevronRight />
      </ScrollButton>
    </div>
  );

  return (
    <StyledPage bannerImg={bannerImg}>
      <HeroSection>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <HeroContent>
            <motion.h1
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Volcanoes & Rift Valleys
            </motion.h1>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Discover Earth's Fiery Heartbeat and Timeless Valleys in Afar
            </motion.p>
          </HeroContent>
        </motion.div>
      </HeroSection>

      <Container>
        <Section>
          <SectionHeader>
            <FaFire className="icon" />
            <h2>Active Volcanoes</h2>
            <AccentLine />
          </SectionHeader>
          {renderCarousel(volcanoes, 1)}
        </Section>

        <Section>
          <SectionHeader>
            <FaMountain className="icon" />
            <h2>Rift Valleys</h2>
            <AccentLine />
          </SectionHeader>
          {renderCarousel(riftValleys, 2)}
        </Section>
      </Container>
    </StyledPage>
  );
};

const StyledPage = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const HeroSection = styled.div`
  height: 80vh;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
              url(${props => props.bannerImg});
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroContent = styled.div`
  text-align: center;
  color: white;
  z-index: 2;

  h1 {
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 1rem;
    background: linear-gradient(45deg, #ffffff, #e0e0e0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.5rem;
    opacity: 0.9;
  }
`;

const Section = styled.section`
  padding: 80px 0;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;

  .icon {
    font-size: 2.5rem;
    color: #2d7ba8;
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 2.5rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }
`;

const AccentLine = styled.div`
  width: 60px;
  height: 4px;
  background: linear-gradient(45deg, #2d7ba8, #34495e);
  margin: 0 auto;
  border-radius: 2px;
`;

const CarouselViewport = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 20px 0;
`;

const CarouselTrack = styled(motion.div)`
  display: flex;
  gap: 20px;
  transition: transform 0.5s ease-in-out;
`;

const Card = styled(motion.div)`
  flex: 0 0 300px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: white;
`;

const CardImage = styled.div`
  position: relative;
  height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.5));
`;

const CardContent = styled.div`
  padding: 20px;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 10px;
    color: #1e293b;
  }

  p {
    color: #64748b;
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  ${props => props.direction === 'left' ? 'left: 0;' : 'right: 0;'}
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export default VolcanoesAndRiftvalleys;